import { all } from 'redux-saga/effects';

import mensagemSaga from './mensagem/combineSaga';
import erroSaga from './erro/combineSaga';

export default all([mensagemSaga, erroSaga]);
